'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './contact-show.routes';

export class ContactShowComponent {
  constructor($stateParams, CommunityService, ContactService, $uibModal, $window, RecentVisits, PinnedItems, PropertyService,
              TaskService, ServiceRequestTicketsService, WorkOrderTicketsService, ViolationTicketsService,
              WebAccessService, QuickbooksImportService, CustomEntityService, SettingsService, StripeService) {
    'ngInject';

    this.back = _ => $window.history.back();
    this.QuickbooksImportService = QuickbooksImportService;
    this.StripeService = StripeService;

    this.contactId = $stateParams.id;
    this.$uibModal = $uibModal;

    this.tasks = [];
    this.activities = [];
    this.custom = [];
    this.balances = [];

    this.contactTypesMap = {};
    this.contactTypes = [];

    this.count = {
      workOrders: 0,
      violations: 0,
      serviceRequests: 0,
      tasks: 0
    };

    this.SettingsService = SettingsService;
    this.ContactService = ContactService;
    this.RecentVisits = RecentVisits;
    this.PinnedItems = PinnedItems;
    this.PropertyService = PropertyService;
    this.CommunityService = CommunityService;

    this.TaskService = TaskService;
    this.ServiceRequestTicketsService = ServiceRequestTicketsService;
    this.WorkOrderTicketsService = WorkOrderTicketsService;
    this.ViolationTicketsService = ViolationTicketsService;

    CommunityService.query(data => {
      this.communities = data;
      this.communityMap = {};
      data.forEach(cmty => this.communityMap[cmty.code] = cmty.name);
    });

    WebAccessService.getByContact({contactId: this.contactId}, data => {
      this.webaccess = data;
    });

    SettingsService.getByName({name: 'config.app'}, appSettings => {
      this.contactTypesMap = appSettings.data.contactTypesMap;
      this.contactTypes = Object.keys(this.contactTypesMap);
    });

    SettingsService.getByName({name: 'custom-fields-views'}, settings => {
      this.customFieldsConfig = settings.data.contact || {};
    });

    SettingsService.getByName({name: 'custom-entities-views'}, settings => {
      this.customEntitiesConfig = settings.data.contact || {display:[]};
      this.customEntitiesConfig.display.forEach(customType => {
        let typeConfig = this.customEntitiesConfig[customType];
        this.custom[customType] = CustomEntityService.getCustomList({type: customType, refField: typeConfig.refField, refId: $stateParams.id});

      });
    });

    this.refreshData();
  }

  getSectionTemplate(section) {
    if (!this.customFieldsConfig.sectionTemplate || !this.customFieldsConfig.sectionTemplate[section])
      return null;

    return this.customFieldsConfig.sectionTemplate[section];
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {

      composedName = contact.firstName;


      if (contact.middleName)
        composedName += " " + contact.middleName;

      composedName += " " + contact.lastName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += ", " + contact.company;
    }

    return composedName || "-";
  }

  getPrimaryEmail(contact) {
    if (!contact || !contact.email || !contact.email.length)
      return "-";

    let email = contact.email.find(email => email.isPrimary) || contact.email[0] || {address:'-'};

    return email.address;
  }

  getAssociations(wa) {
    if (wa.associations && wa.associations.length) {
      return wa.associations.map(code => this.communityMap[code]).join(', ');
    } else {
      return this.communityMap[wa.associationOrGroupCode];
    }
  }

  getAddress(address) {
    try {
      return `${address.street}, ${address.city}, ${address.state} ${address.zip}`;
    } catch (e){
      return "-";
    }
  }

  getAccessForLabel(wa) {
    if (!wa)
      return "";

    let assns = this.getAssociations(wa);

    if (assns && wa.eVotingCode) {
      return assns + " and E-Voting (" + wa.eVotingCode + ")"
    } else if (assns) {
      return assns;
    } else if (wa.eVotingCode) {
      return "E-Voting (" + wa.eVotingCode + ")";
    }

    return "";
  }

  getContactType(contact) {
    // If custom types defined
    if (this.contactTypesMap && this.contactTypes.includes(contact.type))
      return this.contactTypesMap[contact.type];

    // Default
    return contact.type.split("-").join(" ");
  }

  getSectionEditAction(section) {
    if (!this.customFieldsConfig.editAction || !this.customFieldsConfig.editAction[section])
      return null;

    return this.customFieldsConfig.editAction[section];
  }

  editSection(section) {
    let fields = this.getSectionEditAction(section).split(',').map(field => field.trim());

    var that = this;

    this.SettingsService.getByName({name: 'custom-fields'}, customFieldSettings => {
      if (customFieldSettings.data.hasOwnProperty("contact")) {
        let customSchema = customFieldSettings.data.contact;

        let sectionSchema = {
          type: "object",
          properties: {}
        };

        fields.forEach(field => {
          sectionSchema.properties[field] = angular.copy(customSchema.properties[field]);
        });

        const REGEX_ALL = /([^\W_]+[^\s-]*) */g;
        const REGEX_FIRST = /([^\W_]+[^\s-]*)/;
        const capitalize = (input, all) => {
          if (!input) return '';
          const regex = (all) ? REGEX_ALL : REGEX_FIRST;
          return input.replace(regex, (txt) =>
            txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
        };

        var modalInstance = this.$uibModal.open({
          animation: true,
          component: 'schemaFormModal',
          resolve: {
            config: function() {
              return {
                title: capitalize(section, true),
                icon: "pencil-square-o",
                model: (that.contact.customFields) ? angular.copy(that.contact.customFields) : {},
                schema: sectionSchema
              }
            }
          },
          size: 'md'
        });

        modalInstance.result.then(
          function (editedCustomFields) {

            that.contact.customFields = editedCustomFields;

            that.ContactService.update({id: that.contactId}, that.contact, _ => {
              that.refreshData();
            }, err => {
              console.log('could not edit contacts of property');
            });

          },
          function () { }
        );

      }
    });

  }

  refreshData() {
    if (this.contactId) {
      this.ContactService.get({id: this.contactId}, data => {
        this.contact = data;

        this.PropertyService.getPropertiesByVoter({contactId: this.contactId}, data => {
          this.voterRelations = data.map(property => {
            return {
              type: "Property",
              propertyId: property._id,
              property: this.getAddress(property.address) + ` / ${property.lotNo}`,
              lotNo: property.lotNo,
              communityId: property.community._id,
              community: `${property.community.code}: ${property.community.name}`
            }
          });
        });

        this.PropertyService.getByContact({contactId: this.contactId}, data => {
          this.propertyRelations = data.map(property => {
            let idx = property.contacts.findIndex(contact => { return contact.contact == this.contactId; });

            if (idx != -1) {
              return {
                type: this.getContactType(property.contacts[idx]),
                propertyId: property._id,
                property: this.getAddress(property.address) + ` / ${property.lotNo}`,
                lotNo: property.lotNo,
                communityId: property.community._id,
                community: `${property.community.code}: ${property.community.name}`,
                stripeConnectedAccount: property.community && property.community.stripe && property.community.stripe.enabled && property.community.stripe.connectedAccountId ? property.community.stripe.connectedAccountId : null
              }
            }
          });

          this.mapAccount = {};
          this.propertyRelations.filter(pr => pr.stripeConnectedAccount).forEach(pr => this.mapAccount[pr.stripeConnectedAccount] = pr.community);

          this.contactStripeAccounts = [
            ... new Set(
              this.propertyRelations
                .filter(r => r.stripeConnectedAccount)
                .map(r => r.stripeConnectedAccount)
            )
          ];

          this.payments = [];
          this.contactStripeAccounts.forEach(acct => {
            this.StripeService.getPayments({id: acct}, data => {
              this.payments = this.payments.concat(
                data
                  .filter(li  => li.source && li.source.metadata && li.source.metadata.creationUser == this.contactId)
                  .map(li => {
                    li.community = this.mapAccount[acct];
                    return li;
                  })
              );
            });
          });

          this.propertyRelations.forEach(relation => {
            relation.count = {
              workOrders: 0,
              violations: 0,
              serviceRequests: 0,
              tasks: 0
            };

            this.TaskService.getByContext({id: relation.propertyId}, data => {
              let filteredData = data.filter(task => task.status == 'open');
              relation.count.tasks = filteredData.length;
              this.count.tasks += relation.count.tasks;
            });

            this.ServiceRequestTicketsService.getByProperty({id: relation.propertyId}, data => {
              let filteredData = data.filter(sr => sr.status == 'open');
              relation.count.serviceRequests = filteredData.length;
              this.count.serviceRequests += relation.count.serviceRequests;
            });

            this.WorkOrderTicketsService.getByProperty({id: relation.propertyId}, data => {
              let filteredData = data.filter(wo => wo.status == 'open');
              relation.count.workOrders = filteredData.length;
              this.count.workOrders += relation.count.workOrders;
            });

            this.ViolationTicketsService.getByProperty({id: relation.propertyId}, data => {
              let filteredData = data.filter(ccr => ccr.status == 'open');
              relation.count.violations = filteredData.length;
              this.count.violations += relation.count.violations;
            });

            this.QuickbooksImportService.getBalance({propertyId: relation.propertyId}, data => {
              for (let account in data) {
                if (data.hasOwnProperty(account) && !account.startsWith("$")) {
                  let balance = angular.copy(data[account]);
                  balance.account = account;
                  balance.propertyId = relation.propertyId;
                  balance.lotNo = relation.lotNo;
                  this.balances.push(balance)
                }
              }
            });

          });
        });

        this.RecentVisits.addPortfolio(this.contactId, "contact", `${this.contact.firstName} ${this.contact.lastName}`);
        this.isPinned = this.PinnedItems.isPinnedPortfolio(this.contactId);
      }, err => {
        console.log('Could not load contact from server');
      });

      this.TaskService.getByContext({id: this.contactId}, data => {
        let filteredData = data.filter(task => task.status == 'open');
        this.count.tasks += filteredData.length;
      });
    }
  }

  openAssetUploadModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {}
        }
      }
    });

    modalInstance.result.then(resultIds => {
        that.ContactService.addAttachments({id: that.contactId}, resultIds, _ => {
          that.refreshData();
        }, err => {
          console.log('could not add attachments to contact');
        });
      },
      function () { /* cancel */ }
    );

  }

  openSingleAddressLabelModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'singleAddressLabelModal',
      resolve: {
        config: function() {
          let owner = that.contact.firstName;
          if (that.contact.middleName)
            owner += " " + that.contact.middleName;
          owner += " " + that.contact.lastName;

          return {
            owner: owner,
            addresses: that.contact.address
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function () {},
      function () { /* cancel */ }
    );

  }

  emailSectionEdit() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'emailSectionEdit',
      resolve: {
        config: function() {
          return {
            data: that.contact.email
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (newEmails) {
        that.contact.email = newEmails;

        that.ContactService.update({id: that.contactId}, that.contact, _ => {
          that.refreshData();
        }, err => {
          console.log('could not edit emails of contact');
        });
      },
      function () { /* cancel */ }
    );

  }

  phoneSectionEdit() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'phoneSectionEdit',
      resolve: {
        config: function() {
          return {
            data: that.contact.phone
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (newPhones) {
        that.contact.phone = newPhones;

        that.ContactService.update({id: that.contactId}, that.contact, _ => {
          that.refreshData();
        }, err => {
          console.log('could not edit phones of contact');
        });
      },
      function () { /* cancel */ }
    );

  }

  addressSectionEdit() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'addressSectionEdit',
      resolve: {
        config: function() {
          return {
            data: that.contact.address
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (newAddresses) {
        that.contact.address = newAddresses;

        that.ContactService.update({id: that.contactId}, that.contact, _ => {
          that.refreshData();
        }, err => {
          console.log('could not edit addresses of contact');
        });
      },
      function () { /* cancel */ }
    );

  }

}

export default angular.module('conduu.contactShow', [uiRouter])
  .config(routes)
  .component('contactShow', {
    template: require('./contact-show.html'),
    controller: ContactShowComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/portfolio/contact-show/contact-show.component.js